export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-04.f41ac8f9.png";